import { XMLHttpRequest } from '../commons/xhr2';

Object.assign(global, {
    xhr2: XMLHttpRequest,
    XMLHttpRequest,
});
